import React, { Component } from 'react';
import { Button } from 'reactstrap';
import EventsRawTable from '../Components/EventsRawTable/EventsRawTable';
import {useSelector} from 'react-redux';
import { useDispatch } from 'react-redux';
import { openModalEvent } from '../redux/modalSlice';

const EventsAdminView = () => { 
    const {eventsItems} = useSelector((state) => state.events)
    const dispatch = useDispatch();

    return (
      <div className='view-container'>
        <div>
            <Button color="primary" onClick={()=>{dispatch(openModalEvent({event_data_guid:null, read_only:true}))}}>Nouvel évènement</Button>
            <div className='media-container'>
                {/** EventsRawTable */}
                {eventsItems &&
                <EventsRawTable
                  event_list={eventsItems}
                  read_only={false}
                />}
            </div>
        </div>
      </div>
    );
}

export default EventsAdminView;
